export const DEFAULT_VOTE_COOLDOWN_MINUTES = 15;
